import React, { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Question } from "@phosphor-icons/react";
import HowToPlayContent from "@/components/HowToPlayContent";

/**
 * In-game collapsible "How to Play" drawer. Renders a compact trigger button
 * (icon-only on narrow screens) that slides out a right-side sheet containing
 * the full rules + controls. Auto-closes when the user taps outside.
 */
export default function HowToPlayDrawer({ open: openProp, onOpenChange, showTrigger = true }) {
  const [openState, setOpenState] = useState(false);
  // The game page opens it from the bar under the board instead of its own
  // header button (Jack, 2026-10-19), so it can be driven from outside.
  const open = openProp ?? openState;
  const setOpen = onOpenChange ?? setOpenState;
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      {showTrigger && <SheetTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="rounded-full gap-1.5 text-muted-foreground hover:text-foreground"
          data-testid="how-to-play-trigger"
          title="How to play"
        >
          <Question size={16} weight="bold" />
          <span className="hidden sm:inline text-sm">How to play</span>
        </Button>
      </SheetTrigger>}
      <SheetContent
        side="right"
        className="w-full sm:max-w-lg overflow-y-auto bg-background"
        data-testid="how-to-play-drawer"
      >
        <SheetHeader className="mb-6">
          <SheetTitle className="font-display text-2xl font-black tracking-tight">
            How to play <span className="text-brand">Jangle</span>
          </SheetTitle>
        </SheetHeader>
        <HowToPlayContent />
      </SheetContent>
    </Sheet>
  );
}
